module.exports = __webpack_public_path__ + "ced866e1264ddf4df5aacc417b8437d4.MP3";